import React, { useEffect } from 'react';
import L from 'leaflet';
import AvatarOverlay from '../AvatarOverlay';
import { getInitialAvatar } from '../../../../../utils/stringUtils.js';
import './Avatar.css';

const Agent = ({ chair, agent, agentBounds, mapRef, overlays, zoomLevel, mapConfig }) => {
    useEffect(() => {
        try {
            const orphanedTooltips = document.querySelectorAll('.avatar-tooltip, .avatar-tooltip-arrow');
            orphanedTooltips.forEach(tooltip => {
                if (tooltip.parentNode) {
                    tooltip.parentNode.removeChild(tooltip);
                }
            });

            if (!chair || !agent || !mapRef.current || !chair.lat || !chair.lng || !agentBounds || !overlays.current) {
                console.warn("Chair or avatar data is missing or mapRef is not initialized.");
                return;
            }
            let element = null;
            const overlayId = "avatar-" + agent.id;


            const bounds = L.latLngBounds(
                [
                    chair.lat + agentBounds[0][0],
                    chair.lng - agentBounds[0][1],
                ],
                [
                    chair.lat - agentBounds[1][0],
                    chair.lng + agentBounds[1][1],
                ],
            );
  
            const html = `
            <div style="width: 100%; height: 100%; position: relative;">
     
             <div class="user-avatar ${agent?.speaker_state === 0 ? "muted" : ""} user-avatar-on-map in-call" style="width: 100%; height: 100%; position: relative;">
               <rect class="avatar-volume" x="2" y="2" width="46" height="46" rx="18" stroke="#fa764e" strokeWidth="2" fill="#ffbd00" style="transform: scale(1,075);"></rect>
               
            
<figure class="item-thumbnail user-avatar no-bg" style="position: relative;">
    ${agent?.urlphoto === "Avatar.png"
        ? getInitialAvatar(agent?.firstName, agent?.lastName)
        : `<img src="${agent?.urlphoto}" alt="${agent?.display_name || 'agent'}">`
    }
</figure>
               <div class="media-status ${agent?.mic_state === 1 ||
                    agent?.super_mic_state === 1
                    ? "status mic-on"
                    : ""
                }" style="display: initial;"></div>
               <div class="camera-status ${agent?.camera_state === 1 ? "cam" : ""
                }"></div>
               <div class="screen-status ${agent?.screenshare_state === 1 ? "share" : ""
                }"></div>
                <div class="focus-status ${agent?.focus_state === 1 ? "focus" : ""
                }"></div>
               <div class="user-state state state-${agent?.user_status}"></div>

               <span class="avatar-halo avatar-overlay"></span>

               <!-- Affichage conditionnel du display name -->
               <span class="item-tag nametag">
                 <span class="label">${agent?.display_name}</span>
               </span>
             </div>
           </div>`;
            if (!overlays.current[overlayId]) {
                overlays.current[overlayId] = new AvatarOverlay(
                    html,
                    bounds,
                    {
                        className: "custom-avatar-class",
                        interactive: true,
                        opacity: 1,
                        agent: agent,
                        chair_id: chair.id,
                    },
                );
                overlays.current[overlayId].addTo(mapRef.current);
            }
            else {
                const el = overlays.current[overlayId].getElement();
                if (el) {
                        el.innerHTML = html; 
                }
            }
            element = overlays.current[overlayId].getElement();
            element.style.zIndex = 401;
            if (element) {
                try {
                    element.classList.add("active");

                    element
                        .querySelector(".camera-status")
                        ?.classList.toggle(
                            "cam",
                            agent?.camera_state === 1,
                        );
                    element
                        .querySelector(".screen-status")
                        ?.classList.toggle(
                            "share",
                            agent?.screenshare_state === 1,
                        );
                    element
                        .querySelector(".media-status")
                        ?.classList.toggle(
                            "mic-on",
                            agent?.mic_state === 1 ||
                            agent?.super_mic_state === 1,
                        );

                    element
                        .querySelector(".media-status")
                        ?.classList.toggle(
                            "status",
                            agent?.mic_state === 1 ||
                            agent?.super_mic_state === 1,
                        );

                    element
                        .querySelector(".user-avatar")
                        ?.classList.toggle(
                            "muted",
                            agent?.speaker_state === 0,
                        );
                    element
                        .querySelector(".focus-status")
                        ?.classList.toggle(
                            "focus",
                            agent?.focus_state === 1,
                        );
                    const userStateElement =
                        element.querySelector(".user-state");
                    userStateElement?.classList.forEach((cls) => {
                        if (cls.startsWith("state-")) {
                            userStateElement.classList.remove(cls);
                        }
                    });
                    if (agent?.user_status !== undefined) {
                        userStateElement.classList.add(
                            `state-${agent?.user_status}`,
                        );
                    }

                    element.addEventListener("mouseover", () => {
                        element
                            .querySelector(".item-tag")
                            ?.style.setProperty("display", "initial");
                        element
                            .querySelector(".focus-status")
                            ?.style.setProperty("display", "none");
                    
                        element.style.zIndex = 602;
                    });

                    element.addEventListener("mouseout", () => {
                        element
                            .querySelector(".item-tag")
                            ?.style.setProperty("display", "none");
                        element
                            .querySelector(".focus-status")
                            ?.style.removeProperty("display");
                    
                        element.style.zIndex = 401;
                    });
                    const setupTooltip = (button) => {
                        if (!button || !button.dataset.tooltip) return;
                        let tooltipEl = null;
                        let arrowEl = null;
                        const showTooltip = (e) => {
                            if (tooltipEl) return; 
                            const rect = button.getBoundingClientRect();
                            const tooltipText = button.dataset.tooltip;
                            if (!tooltipText) return;
                            tooltipEl = document.createElement('div');
                            tooltipEl.className = 'avatar-tooltip';
                            tooltipEl.textContent = tooltipText;
                            tooltipEl.style.cssText = `
                                position: fixed;
                                background-color: #ffffff;
                                color:rgb(0, 0, 0);
                                font-size: 0.875rem;
                                border-radius: 0.5rem;
                                padding: 0.5rem 0.75rem;
                                font-family: "Roboto", sans-serif;
                                white-space: nowrap;
                                z-index: 99999;
                                box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 
                                           0px 6px 10px 0px rgba(0,0,0,0.14), 
                                           0px 1px 18px 0px rgba(0,0,0,0.12);
                                pointer-events: none;
                                opacity: 0;
                                transition: opacity 0.2s ease-in-out;
                                left: -9999px;
                                top: -9999px;
                                                                font-weight: 600;

                            `;

                            // Create arrow element
                            arrowEl = document.createElement('div');
                            arrowEl.className = 'avatar-tooltip-arrow';
                            arrowEl.style.cssText = `
                                position: fixed;
                                width: 0;
                                height: 0;
                                border-style: solid;
                                border-width: 5px 5px 0 5px;
                                border-color: #ffffff transparent transparent transparent;
                                z-index: 99999;
                                pointer-events: none;
                                transition: opacity 0.2s ease-in-out;
                                filter: drop-shadow(0px 2px 2px rgba(0,0,0,0.1));
                               
                            `;

                            document.body.appendChild(tooltipEl);
                            document.body.appendChild(arrowEl);

                            // Wait for element to be in DOM, then calculate position
                            requestAnimationFrame(() => {
                                const tooltipRect = tooltipEl.getBoundingClientRect();

                                // Position tooltip above button
                                const tooltipTop = rect.top - tooltipRect.height - 8;
                                const tooltipLeft = rect.left + (rect.width / 2) - (tooltipRect.width / 2);

                                tooltipEl.style.top = `${tooltipTop}px`;
                                tooltipEl.style.left = `${tooltipLeft}px`;

                                // Position arrow - collée directement sous la bulle
                                const arrowTop = tooltipTop + tooltipRect.height;
                                const arrowLeft = rect.left + (rect.width / 2) - 5;

                                arrowEl.style.top = `${arrowTop}px`;
                                arrowEl.style.left = `${arrowLeft}px`;

                                // Trigger animation
                                requestAnimationFrame(() => {
                                    tooltipEl.style.opacity = '1';
                                    arrowEl.style.opacity = '1';
                                });
                            });
                        };

                        const hideTooltip = () => {
                            if (tooltipEl) {
                                tooltipEl.style.opacity = '0';
                                arrowEl.style.opacity = '0';
                                setTimeout(() => {
                                    if (tooltipEl && tooltipEl.parentNode) {
                                        tooltipEl.parentNode.removeChild(tooltipEl);
                                    }
                                    if (arrowEl && arrowEl.parentNode) {
                                        arrowEl.parentNode.removeChild(arrowEl);
                                    }
                                    tooltipEl = null;
                                    arrowEl = null;
                                }, 200);
                            }
                        };

                        button.addEventListener('mouseenter', showTooltip);
                        button.addEventListener('mouseleave', hideTooltip);

                        return () => {
                            button.removeEventListener('mouseenter', showTooltip);
                            button.removeEventListener('mouseleave', hideTooltip);
                            if (tooltipEl && tooltipEl.parentNode) {
                                tooltipEl.parentNode.removeChild(tooltipEl);
                            }
                            if (arrowEl && arrowEl.parentNode) {
                                arrowEl.parentNode.removeChild(arrowEl);
                            }
                        };
                    };

                    // Setup tooltips for all action buttons
                    const actionButtons = element.querySelectorAll('.action-button[data-tooltip], .avatar-connection-quality[data-tooltip]');
                    const cleanupTooltips = [];
                    actionButtons.forEach(btn => {
                        const cleanup = setupTooltip(btn);
                        if (cleanup) cleanupTooltips.push(cleanup);
                    });

                    // Store cleanup functions for this element
                    if (!element._tooltipCleanups) {
                        element._tooltipCleanups = [];
                    }
                    element._tooltipCleanups.push(...cleanupTooltips);



                } catch (error) {
                    console.error('Error manipulating avatar element:', error);
                }
            }


            return () => {
                if (element != null) {


                    // Cleanup tooltip event listeners
                    if (element._tooltipCleanups) {
                        element._tooltipCleanups.forEach(cleanup => cleanup());
                        element._tooltipCleanups = [];
                    }

                    const tooltips = document.querySelectorAll('.avatar-tooltip, .avatar-tooltip-arrow');
                    tooltips.forEach(tooltip => {
                        if (tooltip.parentNode) {
                            tooltip.parentNode.removeChild(tooltip);
                        }
                    });
                }
            };
        } catch (error) {
            console.error('Error in agent component:', error);
        }

    }, [agent, chair, agentBounds, zoomLevel, mapConfig]);
};
export default Agent;